module.exports = __webpack_public_path__ + "img/logo.65916aef.png";